<template>
  <MainTable1 />
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref, SetupContext, toRefs } from 'vue';
import MainTable1 from '@/orderControlModule/components/MainTable1.vue';
import { simpleCopy } from '@/utils/deepCopy';
import { newDefaultData } from '@/appLogic/importData/initialData';

export default defineComponent({
  name: 'Inventory',
  components: {
    MainTable1,
  },
  // eslint-disable-next-line jsdoc/require-jsdoc
  setup(props, context: SetupContext) {
    const state = reactive<Record<string, any>>({
      formSet: simpleCopy(newDefaultData),
      formOfTransaction: 'manufacture',
      userPosition: 'buyer',
      privateContents: [],
      registrationModalState: false,
    }) as Record<string, any>;
    const env = ref(process.env.NODE_ENV);

    onMounted(() => {
      state.formSet.businessName = 'これはテストだ';
    });
    return {
      ...toRefs(state),
      env,
    };
  },
});
</script>

<style lang="scss" scoped>
.v_line_fix {
  margin-left: 100px;
  width: 5px;
  height: 150px;
  background-color: brown;
}
.iii {
  padding-left: 30px;
}
</style>
